export const CALENDAR_TABS = [
// DayView is labelled "Week": its multi-day window already reads as a week. The real
// WeekView is disabled (router redirects /admin/calendar/week → .../day), not deleted.
  { to: '/admin/calendar/day',   label: 'Week' },
  // { to: '/admin/calendar/week',  label: 'Week' },
  { to: '/admin/calendar/month', label: 'Month' },
]
